<template>
  <div>
    <a-drawer :title="title" :width="540" :visible="visible" :body-style="{ paddingBottom: '80px' }" :mask-closable="false" @close="close">
      <a-form-model ref="form" :rules="rules" :model="form" layout="vertical">
        <a-form-model-item label="角色名称" prop="role_name">
          <a-input v-model="form.role_name" />
        </a-form-model-item>
        <a-form-model-item label="角色标识" prop="role_code">
          <a-input v-model="form.role_code" />
        </a-form-model-item>
        <a-form-model-item label="角色类型" prop="role_type">
          <a-radio-group v-model="form.role_type" button-style="solid">
            <a-radio-button v-for="(item, key) in roleTypes" :key="key" :value="item.value"> {{ item.label }} </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="备注信息">
          <a-textarea v-model="form.description" :rows="2" placeholder="请输入备注信息" />
        </a-form-model-item>
        <a-form-model-item label="关联权限">
          <div>完全受控: <a-switch v-model="checkStrictly" checked-children="开" un-checked-children="关" /></div>
          <a-tree v-if="permissionData" v-model="form.permissions" :check-strictly="checkStrictly" :default-expand-all="true" checkable :auto-expand-parent="true" :tree-data="permissionData" :replace-fields="replaceFields" />
        </a-form-model-item>
      </a-form-model>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1
        }"
      >
        <a-button :style="{ marginRight: '8px' }" @click="close"> 取消 </a-button>
        <a-button type="primary" :loading="loading" @click="onSubmit"> 提交 </a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { roleAdd, roleModify, roleDetail, permissionList } from '@/api/system/auth';
import { roleTypes } from '@/utils/dictionary';
export default {
  props: {
    roleId: {
      type: [Number, String],
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {},
      roleTypes,
      loading: false,
      permissionData: null,
      checkStrictly: true,
      rules: {
        role_name: [{ required: true, message: '角色名称不能为空', trigger: 'blur' }],
        role_code: [{ required: true, message: '角色标识不能为空', trigger: 'blur' }],
        role_type: [{ required: true, message: '角色类型不能为空', trigger: 'blur' }]
      },
      replaceFields: {
        children: 'children',
        title: 'name',
        key: 'id'
      }
    };
  },
  computed: {
    title() {
      return this.roleId ? '修改角色' : '添加角色';
    }
  },
  watch: {
    visible() {
      if (this.visible === true) {
        this.getPermissionList();
        this.checkStrictly = true;
        if (this.roleId) {
          this.getDetail();
        } else {
          this.form = {
            permissions: []
          };
        }
      }
    }
  },
  methods: {
    close() {
      this.$refs.form.resetFields();
      this.loading = false;
      this.$emit('close');
    },
    getPermissionList() {
      permissionList({}).then(response => {
        this.permissionData = response.data.items;
      });
    },
    getDetail() {
      roleDetail({ role_id: this.roleId }).then(response => {
        const data = response.data;
        this.form = {
          role_name: data.role_name,
          role_code: data.role_code,
          role_type: data.role_type,
          description: data.description,
          permissions: data.permissions
        };
      });
    },

    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.checkStrictly && this.form.permissions.checked) {
            this.form.permissions = this.form.permissions.checked;
          }
          if (this.roleId) {
            roleModify({ ...this.form, role_id: this.roleId })
              .then(() => {
                this.$message.success('角色信息修改成功');
                this.close();
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            roleAdd(this.form)
              .then(() => {
                this.$message.success('角色添加成功');
                this.close();
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    }
  }
};
</script>
